// extracted by mini-css-extract-plugin
export default {"selection-div":"styles_selection-div__Pi5oT"};